import type { FiltrosState } from './ClientesFiltros'

export const FILTROS_INICIALES: FiltrosState = {
  busqueda: '',
  tipoPersona: [],
  estado: 'todos',
  responsable: [],
  condicionFiscal: [],
  impuestos: [],
  provincia: [],
  etiqueta: [],
}
